<template>
  <div
    class="fixed-bottom-left"
    :style="bottomStyle">
    <slot />
  </div>
</template>

<script>
/**
 * @description 画面左下に固定したい場合のコンポーネント
 */
export default {
  props: {
    level: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    bottomStyle() {
      if (this.level === 0) return {}
      const offset = this.level * 60
      return { bottom: `calc(env(safe-area-inset-bottom) + ${96 + offset}px)` }
    },
  },
}
</script>

<style lang="scss" scoped>
.fixed-bottom-left {
  z-index: 100;
  position: fixed;
  bottom: calc(env(safe-area-inset-bottom) + 96px);
  left: calc(env(safe-area-inset-left) + 16px);

  @media (min-width: 992px) {
    // 120px: ナビゲーションサイドバー(NavigationMenuForPC)
    // 302px: コンテンツサイドバー(MemberSelectMenu / CategorySelectMenu)
    // 61px: 余白
    left: 483px;
  }
}
</style>
